import React, { useState } from 'react';
import PrimaryButtonComponent from '../Components/Buttons/PrimaryButton/PrimaryButton.component';
import { httpSignupNewsletter } from '../Hooks/newsletter/newsletter.post.hooks';
import {
  NewsletterSignupContainer,
  NewsletterForm,
  NewsletterInfo,
  NewsletterStatus,
  NewsletterFinePrint,
} from './NewsletterSignup.styles';

const NewsletterSignup = () => {
  const [email, setEmail] = useState('');
  const [honeypot, setHoneypot] = useState('');
  const [status, setStatus] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Honeypot caught a bot
    if (honeypot) {
      setStatus('You have been signed up for our newsletter!');
      return;
    }

    try {
      const res = await httpSignupNewsletter(email.trim(), honeypot);
      const data = await res.json();

      if (res.ok) {
        setStatus(data.msg || 'You have been signed up for our newsletter!');
      } else {
        setStatus(data.msg || 'Failed to sign up for the newsletter');
      }
    } catch (err) {
      setStatus('An error occurred. Please try again');
    }
  };

  return (
    <NewsletterSignupContainer>
      <NewsletterInfo>
        <p className="eyebrowHeader">Safety Updates</p>

        <h3>Stay Informed on Workplace Safety</h3>

        <p>
          Subscribe for monthly updates on safety news, training opportunities,
          compliance reminders, and industry changes.
        </p>
      </NewsletterInfo>

      <NewsletterForm onSubmit={handleSubmit}>
        <input
          name="email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Your email address"
          required
        />

        {/* Honeypot - real users won't see or interact with this */}
        <div
          aria-hidden="true"
          style={{
            position: 'absolute',
            left: '-9999px',
            width: '1px',
            height: '1px',
            overflow: 'hidden',
          }}
        >
          <label htmlFor="newsletter-website">Website</label>
          <input
            id="newsletter-website"
            name="website"
            type="text"
            value={honeypot}
            onChange={(e) => setHoneypot(e.target.value)}
            tabIndex="-1"
            autoComplete="off"
          />
        </div>

        <PrimaryButtonComponent span="Subscribe" />
      </NewsletterForm>

      {status && <NewsletterStatus>{status}</NewsletterStatus>}

      <NewsletterFinePrint>
        Unsubscribe anytime. We respect your privacy.
      </NewsletterFinePrint>
    </NewsletterSignupContainer>
  );
};

export default NewsletterSignup;
